export const environment = {
  production: true,
  apiUrl: 'https://JCI.abc-collect.com/CoreAPI',
  refTableUrl: 'https://JCI.abc-collect.com/#/system/referenceTables;entity=',
  recaptcha: {
    siteKey: '6LftNQ4UAAAAAKVRqpB06Ekzb8U_fGbkbLny0a-a',
  },
  hasPaymentPortal: false
};
